import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import MapViewComponent from '../components/Map/MapView';
import BasketLayout from './Basket';
import { List } from "immutable";
import {translate} from 'react-i18next';
import Spinner from "../components/Spinner/Spinner";


class RecapLayout extends Component {

  constructor(props) {
    super(props);
    this.displayInfo = this.displayInfo.bind(this);
    this.closeInfo = this.closeInfo.bind(this);
    this.state = {
      showInfoIndex: 0
    }
  }

  static renderLoading(t) {
    return (
      <Spinner text={t('loading_restaurants')} />
    );
  }

  displayInfo(value) {
    this.setState({
      showInfoIndex: value
    })
  }

  closeInfo() {
    this.setState({
      showInfoIndex: -1
    })
  }

  render() {
    const { currentRestaurant, t } = this.props;
    const {displayInfo, closeInfo} = this;
    const {showInfoIndex} = this.state;
    if (!currentRestaurant) return RecapLayout.renderLoading(t);
    return (
      <div className='recap'>
        <MapViewComponent
          restaurants={List.of(currentRestaurant)}
          isOpen={true}
          showInfoIndex={showInfoIndex || currentRestaurant.id}
          hideTakeAway={true}
          zoom={18}
          blackWhite={true}
          displayInfo={displayInfo}
          closeInfo={closeInfo}
        />
        <div className='recap__cart'>
          <BasketLayout
            recap={true}
          />
        </div>
      </div>
    );
  }
}


RecapLayout.propTypes = {
  currentRestaurant: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    currentRestaurant: state.restaurants.item,
  }
}

export default connect(mapStateToProps)(translate('translations')(RecapLayout));


// WEBPACK FOOTER //
// ./src/containers/Recap.js